import api from "@/services/api";

export interface SessionAttendanceMentee {
  id: number;
  fullName: string;
  profilePictureSrc: string | null;
  attended: boolean;
}

export interface SessionNoteData {
  text: string | null;
  isPrivate: boolean;
  updatedAt: string;
}

export interface SessionFeedbackItem {
  displayName: string;
  text: string;
  submittedAt: string;
}

export interface SessionAttendanceData {
  session: { id: number; sessionDate: string; sessionTime: string };
  mentor: { fullName: string; email: string; profilePictureSrc: string | null };
  mentees: SessionAttendanceMentee[];
  note: SessionNoteData | null;
  canRecordAttendance: boolean;
  canEditNote: boolean;
  feedbackList: SessionFeedbackItem[];
  canSubmitFeedback: boolean;
  myFeedbackSubmitted: boolean;
  myFeedback: { text: string; isAnonymous: boolean; submittedAt: string } | null;
  isFutureSession: boolean;
}

export async function getSessionAttendance(sessionId: number): Promise<SessionAttendanceData> {
  const { data } = await api.get<SessionAttendanceData>(`/session-attendance/${sessionId}`);
  return data;
}

export async function saveSessionAttendance(
  sessionId: number,
  attendance: { menteeId: number; attended: boolean }[]
): Promise<void> {
  await api.post(`/session-attendance/${sessionId}`, { attendance });
}

export async function saveSessionNote(
  sessionId: number,
  payload: { note: string; isPrivate: boolean }
): Promise<void> {
  await api.patch(`/session-attendance/${sessionId}/note`, payload);
}

export async function submitSessionFeedback(
  sessionId: number,
  payload: { feedback: string; isAnonymous: boolean }
): Promise<void> {
  await api.post(`/session-attendance/${sessionId}/feedback`, payload);
}
